import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { CardSection, Section } from '../../../../styled/sections'
import Cards from '../../../../components/ui/card'
import theme from '../../../../styled/theme'
import fonts from '../../../../styled/fonts'
import Medical from '../../../../assets/icons/medical'
import Syringe from '../../../../assets/icons/syringe'
import { Title } from '../../../../components/ui/text'
import { BackPageHeader } from '../../../../components/ui/header'
import { SEARCH_TYPES } from '../constants'

const DIAGNOSTIC_STUDIES_ROUTE = '/inicio/novedades'

const Container = styled.div`
	width: 100%;
`

// El texto "Volver" se muestra solo en desktop
const BackHeader = styled(BackPageHeader)`
	p {
		@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
			display: none;
		}
	}
`

const SearchTypeSelection = ({ onNext }) => {
	const history = useHistory()

	const cardsList = [
		{
			id: SEARCH_TYPES.MEDICAL_SPECIALTIES,
			title: 'Especialidades médicas',
			subtitle: 'Buscá por especialidad',
			Icon: Medical,
			routes: SEARCH_TYPES.MEDICAL_SPECIALTIES
		},
		{
			id: SEARCH_TYPES.DIAGNOSTIC_STUDIES,
			title: 'Estudios de diagnóstico',
			subtitle: 'Buscá por nombre de estudio',
			Icon: Syringe,
			routes: SEARCH_TYPES.DIAGNOSTIC_STUDIES
		}
	]

	const handleSelectType = type => {
		if (type === SEARCH_TYPES.DIAGNOSTIC_STUDIES) {
			history.push(DIAGNOSTIC_STUDIES_ROUTE)
			return
		}

		onNext()
	}

	return (
		<Container>
			<BackHeader
				hideBackOnMobile={false}
				title={
					<Title
						size={fonts.fontSizes.xxl}
						color={theme.colors.text.titleText}
						margin="0 0 24px 0"
						fontWeight={fonts.fontWeight.semibold}
					>
						¿Qué estás buscando?
					</Title>
				}
			/>
			<Section>
				<CardSection>
					<Cards
						iconColor={theme.colors.brand.green}
						list={cardsList}
						onClick={handleSelectType}
						mobileColumns={1}
						fullMobileCard={true}
						roundedIcon={true}
					/>
				</CardSection>
			</Section>
		</Container>
	)
}

export default SearchTypeSelection
